export enum ENVIRONMENT {
  DEVELOPMENT = 'development',
  LOCAL = 'local',
  PRODUCTION = 'production',
  STAGING = 'staging',
  TEST = 'test',
}
